export type ToCamelCaseOptions = {
  includeNumbers?: boolean;
};

export const toCamelCase = (
  s: string | number | undefined | null,
  hardcore = true,
  options: ToCamelCaseOptions = {}
): string => {
  if (s === null || s === undefined) return '';
  const includeNumbers = options.includeNumbers ?? !hardcore;

  if (hardcore) {
    return `${s}`
      .toLowerCase()
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
        index === 0 ? word.toLowerCase() : word.toUpperCase()
      )
      .replace(/\s+/g, '')
      .replace(/([-_][a-z])/gi, ($1) => {
        return $1.toUpperCase().replace('-', '').replace('_', '');
      })
      .replace(includeNumbers ? /[^a-zA-Z0-9]/g : /[^a-zA-Z]/g, '');
  }

  const normalized = `${s}`
    .toLowerCase()
    .replace(/[()\][]/g, '')
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase()
    )
    .replace(/\s+/g, '')
    .replace(/([-_][a-z])/gi, ($1) => {
      return $1.toUpperCase().replace('-', '').replace('_', '');
    });

  if (includeNumbers) return normalized;
  return normalized.replace(/\d+/g, '');
};
